import { render, staticRenderFns } from "./account-saas.vue?vue&type=template&id=2c8c3ba0&scoped=true"
import script from "./account-saas.vue?vue&type=script&lang=js"
export * from "./account-saas.vue?vue&type=script&lang=js"
import style0 from "./account-saas.vue?vue&type=style&index=0&id=2c8c3ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c3ba0",
  null
  
)

export default component.exports